




















import { Component, Vue, Prop } from 'vue-property-decorator'
import { Room } from '@/class/room'
import { RoomStorage } from '@/class/roomStorage'
import { RoomMember } from '@/class/roomMember'
import BtnSquare from '@/components/Utils/form/button/BtnSquare.vue'
import InputText from '@/components/Utils/form/text/InputText.vue'

@Component({
  components: {
    BtnSquare,
    InputText
  }
})

export default class PlayerUI extends Vue {
  @Prop() room!: Room;
  @Prop() self!: RoomMember;
  @Prop() roomStorage!: RoomStorage;
  newName = '';

  created () {
    this.newName = this.self.name
  }

  get isRoomMaster () {
    return this.room.masterId === this.self.id
  }

  updateName () {
    this.self.updateName(this.newName)
  }

  toggleReady () {
    this.self.setReady(!this.self.ready)
  }

  leave () {
    if (confirm('退室しますか？')) {
      this.room.removeRoomMember(this.self.id)
      this.roomStorage.removeData()
      this.$router.replace({ name: 'room', params: { roomId: this.room.id } })
    }
  }
}
